import { SHARE_NOTIFICATION, SHARE_UPDATE_USER_LIST } from "../actions/types";
import i18n from "./../components/helper/i18n";
// import { logout } from "../actions/authActions";

const initialState = {
  userList: [],
  shareNotification: "",
};

//will later get state from api

export default function (state = initialState, action) {
  switch (action.type) {
    case SHARE_NOTIFICATION:
      return {
        ...state,
        shareNotification: action.payload,
      };

    case SHARE_UPDATE_USER_LIST:
      if (action.payload.hasOwnProperty("userList")) {
        return {
          ...state,
          userList: action.payload.userList,
        };
      } else if (action.payload.hasOwnProperty("delete")) {
        let fInd = state.userList.findIndex(
          (x) => x.id === action.payload.delete
        );
        let userList = state.userList;
        if (fInd > -1 && fInd < state.userList.length) {
          userList.splice(fInd, 1);
        }
        return {
          ...state,
          userList,
        };
      }

    default:
      return state;
  }
}
